import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import { NgForm, NgModel } from '@angular/forms'
import { AnoSafra } from 'src/app/classes/AnoSafra'
import { Cultura } from 'src/app/classes/Cultura'
import { Empresa, enumErpIntegrado } from 'src/app/classes/Empresa'
import { Safra } from 'src/app/classes/Safra'
import { CulturaService } from 'src/app/services/cultura.service'
import { SafraService } from 'src/app/services/safra.service'
import { StorageService } from 'src/app/services/storage.service'
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component'
import { UtilsService } from 'src/app/utils/utils.service'
import Swal from 'sweetalert2'

@Component({
  selector: 'app-forms-cultura-safra',
  templateUrl: './forms-cultura-safra.component.html',
  styleUrls: ['./forms-cultura-safra.component.scss'],
})
export class FormsCulturaSafraComponent implements OnInit, OnChanges {
  @ViewChild('Modal', { static: false })
  modal: UiModalComponent
  @ViewChild('formulario', { static: false }) formulario!: NgForm;
  @Output() finalizarSave: EventEmitter<any> = new EventEmitter()
  @Output() gerenciarTalhoes: EventEmitter<any> = new EventEmitter()
  @Output() culturaId = new EventEmitter<number>();
  @Input() anoSafra: AnoSafra
  @Input() culturasSafras: Cultura[] = [];

  culturas: Cultura[] = []
  enumErp = enumErpIntegrado
  safra: Safra = new Safra()
  isSubmit: boolean = false
  carregando: boolean = false
  empresa: Empresa
  usarProjetos:boolean = false;
  constructor(
    private safraService: SafraService,
    private utils: UtilsService,
    private culturaService: CulturaService,
    private storageService: StorageService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
      if (changes['culturasSafras']) {
          this.listarCulturas()
    }
  }

  ngOnInit() {
    this.empresa = this.storageService.getEmpresa()
    this.usarProjetos = this.empresa.UsaProjetos;
  }

  abrirModal(safra: Safra = null): void {
    if (safra != null) this.safra = safra
    else this.safra = new Safra()
    this.isSubmit = false
    this.formulario.reset()
    this.modal.show()
  }

  fecharModal(): void {
    this.modal.hide()
  }

  isCampoInvalido(campo: NgModel): boolean {
    return !campo.valid && (campo.dirty || campo.touched || this.isSubmit)
  }

  listarCulturas(): void {
    this.culturaService.getCulturas().subscribe(
      (res) => {
        this.culturas = res.filter(cultura =>
          !this.culturasSafras.some(c => c.Id === cultura.Id)
        );
  },
      (err) => {
        this.utils.getErro(err)
      },
    )
  }

  save(): void {
    this.carregando = true

    if (!this.validarForm()) return

    if (this.safra.Id) {
      this.safraService.putSafra(this.safra.Id, this.safra).subscribe(
        (res) => {
          this.finalizarSaveRequestSuccess('Cultura alterada com sucesso!')
          this.culturaId.emit(this.safra.CulturaId);
        },
        (err) => {
          this.finalizarRequestError(err)
        },
      )
    } else {
      if (!this.safra.Descricao)
        this.safra.Descricao =
          this.culturas.find((p) => p.Id == this.safra.CulturaId).Descricao +
          ' ' +
          this.anoSafra.Descricao

      this.safra.Padrao = true
      this.safra.AnoSafraId = this.anoSafra.Id
      this.safraService.postSafra(this.safra).subscribe(
        (res) => {
          this.finalizarSaveRequestSuccess('Cultura cadastrada com sucesso!')
          this.culturaId.emit(this.safra.CulturaId);
          this.exibirAlertRedirectTalhoes()
        },
        (err) => {
          this.finalizarRequestError(err)
        },
      )
    }
  }

  exibirAlertRedirectTalhoes(): void {
    Swal.fire({
      title: 'Próximos Passos',
      text:
        'A Cultura foi inserida no Ano Safra com sucesso! Agora, você pode partir para a determinação e configuração dos Talhões que farão parte dela. Para isso clique no botão “Adicionar Talhões”.',
      type: 'success',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: 'Deixar pra depois',
      confirmButtonText: 'Adicionar Talhões',
    }).then((response) => {
      if (!response.dismiss) {
        this.gerenciarTalhoes.emit()
      }
    })
  }

  validarForm(): boolean {
    console.debug(this.safra)
    console.debug(this.formulario)
    if (this.formulario.invalid) {
      this.isSubmit = true
      this.carregando = false
      this.utils.handleWarning(
        'Por favor, preencha todos os campos obrigatórios corretamente.',
      )
      return false
    }

    return true
  }

  finalizarSaveRequestSuccess(msg: string): void {
    this.utils.handleSuccess(msg)
    this.carregando = false
    this.finalizarSave.emit()
    this.fecharModal()
  }

  finalizarRequestError(error: any): void {
    this.utils.getErro(error)
    this.carregando = false
  }
}
